import React from "react";
import { Container, Row } from "react-bootstrap";
import { CgEditMarkup } from "react-icons/cg";
const Policy=()=>{
return(
    <div>

            <center>
        <h1 className="heading">Privacy Policy</h1>
        </center>
        <Container>
        <Row className="terms">
        <p>We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and store your data when you use Itok.</p>
        <ol>
<li><strong>Personal Information</strong> – When you use Itok, we collect your email address and mobile number. We may also collect data on how you use the app, such as the voice commands you issue and the responses you receive.</li>



<li><strong>Data Usage</strong> – We use your personal data to provide you with support and to improve the app’s performance. We may also use your data to personalize your experience with the app.</li>



<li><strong>Data Storage</strong> – We store your personal data in Firebase, a cloud-based database platform. We take reasonable steps to protect your data from unauthorized access or disclosure.</li>



<li><strong>Data Sharing</strong> – We do not share your personal data with third parties, except as required</li>
</ol>

        </Row>
        </Container>
    </div>
)}

export default Policy